function HeroSectionContainer({children} : {children: any}) {
    
    return ( 
        <section className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-80px)] pt-20">
            {children}
        </section>
     );
}

export default HeroSectionContainer;